<div class="hero_area2">
    <app-menu [config]="config"></app-menu>
    <!-- <app-carrossel [config]="config"></app-carrossel> -->
</div>
<app-pesquisa-body [config]="config"></app-pesquisa-body>

